var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6313333,13.6346667 L11.262,13.6346667 L11.262,9.922 C11.262,9.03666667 11.244,7.89733333 10.0273333,7.89733333 C8.792,7.89733333 8.60333333,8.86066667 8.60333333,9.85666667 L8.60333333,13.6346667 L6.234,13.6346667 L6.234,6 L8.51,6 L8.51,7.04066667 L8.54066667,7.04066667 C8.85866667,6.44066667 9.632,5.80733333 10.7873333,5.80733333 C13.188,5.80733333 13.632,7.38733333 13.632,9.444 L13.632,13.6346667 L13.6313333,13.6346667 Z M3.558,4.95533333 C2.79533333,4.95533333 2.18266667,4.338 2.18266667,3.57866667 C2.18266667,2.82 2.796,2.20333333 3.558,2.20333333 C4.318,2.20333333 4.934,2.82 4.934,3.57866667 C4.934,4.338 4.31733333,4.95533333 3.558,4.95533333 Z M4.746,13.6346667 L2.37,13.6346667 L2.37,6 L4.746,6 L4.746,13.6346667 Z M14.8166667,0 L1.18066667,0 C0.528,0 0,0.516 0,1.15266667 L0,14.8473333 C0,15.4846667 0.528,16 1.18066667,16 L14.8146667,16 C15.4666667,16 16,15.4846667 16,14.8473333 L16,1.15266667 C16,0.516 15.4666667,0 14.8146667,0 L14.8166667,0 Z",
    fill: "#0177B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ca75acfd65bb6fc26776c980a1859d56.svg";
export { ForwardRef as ReactComponent };